// extracted by mini-css-extract-plugin
export default {"actions":"games_actions__Y-HEu"};